import { Component } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AirportPickerComponent } from '../../results-search/airport-picker/airport-picker.component';

/**
 * From / To of the home search: the results-page search's airport picker (recent searches, popular cities,
 * typed results grouped by city, keyboard), the same logic, its look in Tailwind (the home has no .rsx styles).
 * The dropdown opens over the field, with the field (input) on top.
 */
@Component({
  selector: 'app-home-airport-picker',
  imports: [NgClass, NgTemplateOutlet, TranslateModule],
  templateUrl: './home-airport-picker.component.html',
  host: { style: 'display: contents' },
})
export class HomeAirportPickerComponent extends AirportPickerComponent {}
